import React from "react";
import styled from "styled-components";
import { Color } from "../colors/colors";

const Wrapper = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  position: fixed;
  height: 100vh;
  width: 100vw;
  top: 0;
  left: 0;
  background: rgba(164, 178, 189, 0.78);
  z-index: 999999;
`;

const LoadingWrapper = styled.div`
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  font-size: 40px;
  text-align: center;
  margin-left: auto;
  margin-right: auto;

  span {
    display: inline-block;
    width: 28px;
    height: 28px;
    border-radius: 50%;
    margin: 0px 10px;
    background: white;
    animation: wave 1.3s linear infinite;

    &:nth-child(2) {
      animation-delay: -1.1s;
      background-color: ${Color.Grey};
    }

    &:nth-child(3) {
      animation-delay: -0.9s;
    }

    &:nth-child(4) {
      animation-delay: -0.7s;
      background-color: ${Color.Grey};
    }
    &:nth-child(5) {
      animation-delay: -0.4s;
    }
  }
`;

const Loading = () => {
  return (
    <Wrapper>
      <LoadingWrapper>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
        <span></span>
      </LoadingWrapper>
    </Wrapper>
  );
};

export default Loading;
